import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { ContextUserProfile } from '../../../contexts/UserProfileContext';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import '../../../stylesheets/stylesLayout/dashboard.scss';
import { ownerPortalMenu } from '../../../utils/menusData';
import DashboardCharts from './dashboardCharts/DashboardCharts';
import Icon from '../../../muiComponents/Icon';
import Card from '../../../muiComponents/Card';
import Grid from '../../../muiComponents/Grid';
import GridChild from '../../../muiComponents/GridChild';
import {
    cardChildGrid,
    cardsGridSpacing,
} from '../../../utils/dashboard/dashbordUtils';

export default function OwnerPortalLanding() {
    const history = useHistory();
    const { translate } = useContext(ContextUserProfile);

    return (
        <div className='dashboard__container'>
            <header>
                <SectionTitle
                    className='padding-inline-10'
                    title={translate('welcome_to_your_private_area')}
                />
            </header>
            <main className='flex-grow flex-column gap-20'>
                <section>
                    <Grid
                        className='margin-0'
                        columnSpacing={cardsGridSpacing}
                        rowSpacing={cardsGridSpacing}
                    >
                        {ownerPortalMenu.map(item => {
                            return (
                                <GridChild
                                    key={item.text}
                                    gridProps={cardChildGrid}
                                >
                                    <Card
                                        className='cursor-pointer padding20 flex-column gap-10 height100perc'
                                        onClick={() => history.push(item.link)}
                                    >
                                        <div className='flex flex-align-center gap-10'>
                                            <Icon
                                                fontSize='medium'
                                                iconName={item.icon}
                                                className={`text-secondary-color`}
                                            />
                                            <h3 className='font-weight-600'>
                                                {translate(item.text)}
                                            </h3>
                                        </div>
                                        <div>
                                            <p className='menu-card__subtitle'>
                                                {translate(
                                                    `subtitle_${item.text}`
                                                )}
                                            </p>
                                        </div>
                                    </Card>
                                </GridChild>
                            );
                        })}
                    </Grid>
                </section>
                <section className='flex-grow flex-column gap-10'>
                    <SectionTitle
                        className='padding-inline-10'
                        title={translate('your_statistics')}
                        variant={'h2'}
                    />
                    <DashboardCharts />
                </section>
            </main>
        </div>
    );
}
